<template>
	<section class="blocks bg-white">
		<div class="container">
			<h2 class="title-box">COMPONENTE MENSAGEM</h2>
		</div>
	</section>
</template>

<script>
    export default {
        props: [""]
    }
</script>

<style lang="scss">
	.blocks {
		padding: 60px 0;

		article {
			p {
				color: #222831;
				font-size: 1.6em;
				line-height: 24px;
				margin-bottom: 25px;
				text-align: center;
			}
		}

		figure {
			padding: 40px 0;
			text-align: center;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/message/message.vue